module.exports = __webpack_public_path__ + "static/media/presskit_extrawide.8583c9fd.png";